import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { BootstrapVue } from "bootstrap-vue";
import routes, { createRouterGuard } from "./routes";
import store from "./store";
import ApiService from "./core/services/api.service";
import { formatMoney } from "./core/helpers/money";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/pos-glass.css";
import "@/assets/css/app.css";
import { parseDashboardNumeric } from "./core/helpers/main.js";
import VueProgressBar from "vue-progressbar";
import VueGoodTablePlugin from "vue-good-table";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import swal from "sweetalert2";
import {
  faUserSecret,
  faEye,
  faEnvelope,
  faKey,
  faBackward,
  faForward,
  faLayerGroup,
  faHouseDamage,
  faArrowDown,
  faUsers,
  faUser,
  faTasks,
  faBook,
  faCodeBranch,
  faChartBar,
  faUniversity,
  faCalendarWeek,
  faHandHoldingDollar,
  faExchangeAlt,
  faPiggyBank,
  faMoneyBill,
  faUserCircle,
  faTrash,
  faEdit,
  faShare,
  faBriefcase,
  faWeightHanging,
  faWindowRestore,
  faSearch,
  faSave,
  faTimes,
  faCircleCheck,
  faMoneyBillTransfer,
  faCheck,
  faBan,
  faArrowRotateLeft,
  faCircle,
  faFileExcel,
  faDownload,
  faHandHolding,
  faCaretSquareDown,
  faUpload,
  faFilter,
  faPlus,
  faRotateRight,
  faRotateLeft,
  faClose,
  faFilePdf,
  faCalculator,
  faCertificate,
  faPeopleGroup,
  faDoorOpen,
  faScaleBalanced,
  faLegal,
  faReceipt,
  faLink,
  faToggleOn,
  faToggleOff,
  faPrint,
  faPaperclip,
  faMailForward,
  faCirclePlay,
  faEllipsis,
  faPaperPlane,
  faDollarSign,
  faHistory,
  faUserFriends,
  faMapMarker,
  faMapMarkedAlt,
  faMapLocation,
  faMapMarkerAlt,
  // fa Icon to represent loan repayment
  faHandHoldingUsd,
  faEllipsisV,
  faMagnifyingGlass,
  faBarsProgress,
  faCopy,
  faLandmark,
  faWarehouse,
  faCoins,
  faCashRegister,
  faBell,
  faComments,
  faArrowRight,
  faMinus,
  faClockRotateLeft,
  faVault,
  faTag,
  faBoxesStacked,
  faRightLeft,
  faChartLine,
  faFileInvoice,
  faFileInvoiceDollar,
  faDashboard,
  faBoxOpen,
  faTruck,
  faCogs,
  faCircleXmark,
  faTags,
  faKeyboard,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";

window.swal = swal;
const toast = swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener("mouseenter", swal.stopTimer);
    toast.addEventListener("mouseleave", swal.resumeTimer);
  },
  background: "#ffffff",
});
Vue.use(VueProgressBar, {
  // color: 'rgb(143,255,199)',
  color: "blue",
  failedColor: "red",
  height: "6px",
});
Vue.use(VueGoodTablePlugin);

window.toast = toast;

Vue.use(VueRouter);
Vue.use(BootstrapVue);

Vue.component("font-awesome-icon", FontAwesomeIcon);

library.add(
  faUserSecret,
  faEye,
  faEnvelope,
  faKey,
  faBackward,
  faForward,
  faLayerGroup,
  faHouseDamage,
  faArrowDown,
  faArrowRight,
  faUsers,
  faUser,
  faTasks,
  faBook,
  faCodeBranch,
  faChartBar,
  faUniversity,
  faCalendarWeek,
  faHandHoldingDollar,
  faExchangeAlt,
  faPiggyBank,
  faMoneyBill,
  faUserCircle,
  faTrash,
  faEdit,
  faShare,
  faBriefcase,
  faWeightHanging,
  faWindowRestore,
  faSearch,
  faSave,
  faTimes,
  faCircleCheck,
  faMoneyBillTransfer,
  faCheck,
  faBan,
  faArrowRotateLeft,
  faCircle,
  faFileExcel,
  faDownload,
  faHandHolding,
  faCaretSquareDown,
  faUpload,
  faFilter,
  faDoorOpen,
  faPlus,
  faRotateRight,
  faRotateLeft,
  faClose,
  faFilePdf,
  faCalculator,
  faCertificate,
  faPeopleGroup,
  faDoorOpen,
  faScaleBalanced,
  faLegal,
  faReceipt,
  faLink,
  faToggleOn,
  faToggleOff,
  faPrint,
  faPaperclip,
  faMailForward,
  faCirclePlay,
  faEllipsis,
  faPaperPlane,
  faDollarSign,
  faHistory,
  faUserFriends,
  faMapMarker,
  faMapMarkedAlt,
  faMapLocation,
  faMapMarkerAlt,
  faHandHoldingUsd,
  faEllipsisV,
  faMagnifyingGlass,
  faBarsProgress,
  faCopy,
  faLandmark,
  faWarehouse,
  faCoins,
  faCashRegister,
  faBell,
  faComments,
  faMinus,
  faClockRotateLeft,
  faVault,
  faTag,
  faBoxesStacked,
  faRightLeft,
  faChartLine,
  faFileInvoice,
  faFileInvoiceDollar,
  faDashboard,
  faBoxOpen,
  faTruck,
  faCogs,
  faCircleXmark,
  faTags,
  faKeyboard,
  faShoppingCart,
);
ApiService.init();

Vue.mixin({
  methods: {
    formatMoney,
    isEmpty: function (strIn) {
      if (strIn === undefined) {
        return true;
      } else if (strIn == null) {
        return true;
      } else if (strIn == "") {
        return true;
      } else {
        return false;
      }
    },
    formatDateAndTime(dateStr) {
      const date = new Date(dateStr);
      // Format date part: Jun 9, 2025
      const datePart = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      });

      // Format time part: 3:18 PM
      const timePart = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "UTC",
      });

      return `${datePart} - ${timePart}`;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);

      const datePart = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC",
      });

      return `${datePart}`;
    },
    displayNumber(number) {
      const num = parseDashboardNumeric(number);
      if (num == null || num === 0) {
        return "0.00";
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    numberToWords(num) {
      if (num != undefined) {
        const belowTwenty = [
          "",
          "One",
          "Two",
          "Three",
          "Four",
          "Five",
          "Six",
          "Seven",
          "Eight",
          "Nine",
          "Ten",
          "Eleven",
          "Twelve",
          "Thirteen",
          "Fourteen",
          "Fifteen",
          "Sixteen",
          "Seventeen",
          "Eighteen",
          "Nineteen",
        ];
        const tens = [
          "",
          "",
          "Twenty",
          "Thirty",
          "Forty",
          "Fifty",
          "Sixty",
          "Seventy",
          "Eighty",
          "Ninety",
        ];
        const aboveThousand = ["", "Thousand", "Million", "Billion"];

        if (num === 0) return "Zero";

        let words = "";

        function helper(n) {
          if (n < 20) return belowTwenty[n];
          if (n < 100)
            return (
              tens[Math.floor(n / 10)] +
              (n % 10 ? " " + belowTwenty[n % 10] : "")
            );
          if (n < 1000)
            return (
              belowTwenty[Math.floor(n / 100)] +
              " Hundred" +
              (n % 100 ? " " + helper(n % 100) : "")
            );
          for (let i = 0; i < aboveThousand.length; i++) {
            const unit = Math.pow(1000, i);
            if (n < unit * 1000) {
              return (
                helper(Math.floor(n / unit)) +
                " " +
                aboveThousand[i] +
                (n % unit ? " " + helper(n % unit) : "")
              );
            }
          }
        }

        words = helper(num);
        return words.trim();
      }
    },
    statusBadge(item) {
      if (item) {
        return "badge akkurate-green-bg";
      } else {
        return "badge akkurate-gray-bg";
      }

      return "badge akkurate-warning-bg";
      // if (item === 'APPROVED') {
      // 	return 'badge akkurate-blue-bg'
      // } else if (item === 'REJECTED') {
      // 	return 'badge akkurate-danger-bg'
      // } else if (item === 'RUNNING') {
      // 	return 'badge akkurate-green-bg'
      // } else if (item === 'PENDING') {
      // 	return 'badge akkurate-warning-bg'
      // } else if (item === 'REVERSED') {
      // 	return 'badge akkurate-orange'
      // } else if (item === 'EXPIRED') {
      // 	return 'badge akkurate-gray-bg'
      // } else {
      // 	return 'badge akkurate-warning-bg'
      // }
    },
    payStatusBadge(item) {
      const status = item?.toUpperCase();
      if (status === "APPROVED") {
        return "badge akkurate-blue-bg";
      } else if (status === "REFUNDED" || status === "REJECTED") {
        return "badge akkurate-danger-bg";
      } else if (status === "COMPLETED" || status === "RUNNING") {
        return "badge akkurate-green-bg";
      } else if (status === "PENDING" || status === "HELD") {
        return "badge akkurate-warning-bg";
      } else if (status === "VOIDED" || status === "EXPIRED") {
        return "badge akkurate-gray-bg";
      } else {
        return "badge akkurate-warning-bg";
      }
    },
    formatNumberWithInitials(num) {
      const absNum = Math.abs(num);
      let formatted;

      if (absNum >= 1_000_000_000) {
        formatted = (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
      } else if (absNum >= 1_000_000) {
        formatted = (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
      } else if (absNum >= 1_000) {
        formatted = (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
      } else {
        formatted = num.toLocaleString(); // adds commas for thousands
      }

      return `GHS ${formatted}`;
    },
    convertMoneyToWords(amount) {
      if (amount != undefined) {
        const [wholePart, decimalPart] = amount.toString().split(".");
        let words = this.numberToWords(parseInt(wholePart)) + " Cedis";

        if (decimalPart) {
          words +=
            " and " + this.numberToWords(parseInt(decimalPart)) + " Pesewas";
        }

        return words;
      }
    },
    getCustomerFullName(customer) {
      return [customer?.first_name, customer?.middlename, customer?.last_name]
        .filter(Boolean)
        .join(" ");
    },
    getUserFullName(user) {
      return [user?.first_name, user?.surname].filter(Boolean).join(" ");
    },
    // Utility function to Print And Download PDF
    async DownloadingPDF(url, filename) {
      try {
        const response = await ApiService.query(url, {
          responseType: "blob",
        });

        const blobUrl = URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" }),
        );

        const a = document.createElement("a");
        a.style.display = "none";
        a.href = blobUrl;
        a.download = filename || "statement.pdf";

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);

        return true;
      } catch (error) {
        console.error("Download process collapsed", error);
        return false;
      }
    },
    // Utility function to Print PDF natively
    async PrintingPDF(url) {
      // Option A: Use the direct backend URL (not blob)
      const pdfWindow = window.open(url, "_blank", "width=800,height=600");
      if (pdfWindow) {
        pdfWindow.onload = () => {
          pdfWindow.print();
        };
      } else {
        console.error("Popup blocked. Allow popups for this site.");
        // Alternative: use a hidden iframe with the direct URL
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          iframe.contentWindow.print();
          setTimeout(() => document.body.removeChild(iframe), 10000);
        };
      }
      return true;
    },
    StatementGenerateAlert(isPrint = true, titleMsg = "Statement") {
      const baseMsg = isPrint ? "Printing " : "Downloading ";
      toast.fire({
        icon: "info",
        title: baseMsg + titleMsg,
      });
    },
  },
});

const router = new VueRouter({
  mode: "history",
  routes,
});

createRouterGuard(router, store);

if (store.getters.isAuthenticated) {
  store.dispatch("loadSettings");
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
